import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { CalendarPlus, LogOut, ShieldCheck, User2 } from "lucide-react";
import { NAV } from "@/constants/testIds";

const LOGO_URL = "/maurizi-logo.jpg";

export function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const isActive = (p) => loc.pathname === p;

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#F9F8F6]/85 border-b border-border">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid={NAV.logo} className="flex items-center gap-3">
          <img src={LOGO_URL} alt="Maurizi" className="h-8 md:h-9 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          <Link to="/" data-testid={NAV.home} className={`px-3 py-2 rounded-md text-sm ${isActive("/") ? "text-primary font-semibold" : "text-foreground/70 hover:text-foreground"}`}>Home</Link>
          <a href="/#servizi" data-testid={NAV.services} className="px-3 py-2 rounded-md text-sm text-foreground/70 hover:text-foreground">Servizi</a>
          <Link to="/chi-siamo" data-testid="nav-chi-siamo" className={`px-3 py-2 rounded-md text-sm ${isActive("/chi-siamo") ? "text-primary font-semibold" : "text-foreground/70 hover:text-foreground"}`}>Chi siamo</Link>
          <Link to="/prenota" data-testid={NAV.book} className={`px-3 py-2 rounded-md text-sm ${isActive("/prenota") ? "text-primary font-semibold" : "text-foreground/70 hover:text-foreground"}`}>Prenota</Link>
          {user && (
            <Link to="/le-mie-prenotazioni" data-testid={NAV.myBookings} className={`px-3 py-2 rounded-md text-sm ${isActive("/le-mie-prenotazioni") ? "text-primary font-semibold" : "text-foreground/70 hover:text-foreground"}`}>Le mie prenotazioni</Link>
          )}
          {user?.role === "admin" && (
            <Link to="/admin" data-testid={NAV.admin} className={`px-3 py-2 rounded-md text-sm flex items-center gap-1 ${isActive("/admin") ? "text-primary font-semibold" : "text-foreground/70 hover:text-foreground"}`}>
              <ShieldCheck className="h-4 w-4" /> Admin
            </Link>
          )}
        </nav>

        <div className="flex items-center gap-2">
          <Button asChild size="sm" className="hidden sm:inline-flex rounded-full">
            <Link to="/prenota" data-testid="nav-cta-book"><CalendarPlus className="h-4 w-4 mr-2" /> Prenota</Link>
          </Button>
          {!user ? (
            <Button asChild variant="outline" size="sm" className="rounded-full" data-testid={NAV.login}>
              <Link to="/login">Accedi</Link>
            </Button>
          ) : (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button data-testid={NAV.userMenu} className="flex items-center gap-2 rounded-full border border-border bg-white pl-1 pr-3 py-1 hover:border-primary/40 transition">
                  {user.picture ? (
                    <img src={user.picture} alt={user.name} className="h-7 w-7 rounded-full" />
                  ) : (
                    <span className="h-7 w-7 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-xs font-semibold">{user.name?.[0]?.toUpperCase() || "U"}</span>
                  )}
                  <span className="text-sm hidden sm:block">{user.name?.split(" ")[0]}</span>
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                <DropdownMenuItem onClick={() => nav("/le-mie-prenotazioni")}><User2 className="h-4 w-4 mr-2" /> Le mie prenotazioni</DropdownMenuItem>
                <DropdownMenuItem onClick={() => nav("/account")}><User2 className="h-4 w-4 mr-2" /> Account</DropdownMenuItem>
                {user.role === "admin" && (
                  <DropdownMenuItem onClick={() => nav("/admin")}><ShieldCheck className="h-4 w-4 mr-2" /> Dashboard admin</DropdownMenuItem>
                )}
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => { logout(); nav("/"); }} data-testid={NAV.logout}>
                  <LogOut className="h-4 w-4 mr-2" /> Esci
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </div>
      </div>
    </header>
  );
}
